import React, { useState } from 'react';
import { EventRow6Pack } from 'src/domains/sportsbook/webview/components/eventsList/eventRow6Pack/EventRow6Pack';
import { observer } from 'src/utils/mobx-react';
import { MLBEventRow6PackState } from './EventRowMLB.state';
import { EventListGroupEventItemType } from 'src_common/common/websocket2/modelsApi/EventsCollectionQuery';
import { EventId } from 'src_common/common/websocket2/id/WebsocketId';
import { useCommon } from 'src/domains/common/Common';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';

interface PropsType {
    eventId: EventId;
    smallEvent: EventListGroupEventItemType;
}

export const EventRowMLB = observer<PropsType>('EventRowMLB', ({ eventId, smallEvent }) => {
    const common = useCommon();
    const languagesState = LanguagesState.get(common);
    const [state] = useState(() => new MLBEventRow6PackState(eventId, languagesState));

    return (
        <EventRow6Pack
            smallEvent={smallEvent}
            state={state}
        />
    );
});
